import styled from 'styled-components';

export const Badge = styled.span`
  --badge-color: ${props => props.$color || 'var(--text-secondary)'};
  background: color-mix(in srgb, var(--badge-color) 8%, var(--white));
  color: var(--badge-color);
  padding: 4px 12px;
  border-radius: var(--radius-round);
  font-size: var(--text-xs);
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  border: 1px solid color-mix(in srgb, var(--badge-color) 28%, transparent);
  display: inline-flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;

  &::before {
    content: '';
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: var(--badge-color);
  }
`;
